import {
  getSettingValueWithoutAssignment,
  assignSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { ENABLE_THROTTLED_QUICK_ADD_TO_CARTS_250307 } from "@faire/web-api--source/indigofair/settings/ENABLE_THROTTLED_QUICK_ADD_TO_CARTS_250307";

export const getSettingThrottledQuickAdds = (): boolean =>
  getSettingValueWithoutAssignment(
    ENABLE_THROTTLED_QUICK_ADD_TO_CARTS_250307,
    false
  );

export const assignSettinThrottleQuickAdds = () =>
  assignSetting(ENABLE_THROTTLED_QUICK_ADD_TO_CARTS_250307);
